export default __webpack_public_path__ + "static/media/louis-hansel-TnHuJLzB8po-unsplash.6d290b26.jpg";